import React, { ChangeEvent } from 'react';
import { Grid, TextInput } from '@ts/storybook';
import { WrapperEntitySelector } from '@components/Inputs';
import { ICreateWarningRule } from '@ts/ui-models';
import { generateSearchEntitySelector } from '@modules/entitySelector/entitySelector.utils';

interface MainInformationStep1Props {
  formData: ICreateWarningRule;
  setFormData: (attr: string) => (event: ChangeEvent | null, value: string | string[] | number | null) => void;
  requiredFields: string[];
  isPreview?: boolean;
}

const MainInformationStep1: React.FC<MainInformationStep1Props> = props => {
  const focus = props.requiredFields[0] ?? 'name';

  return (
    <Grid container spacing={2} justifyContent="flex-start">
      <Grid size={{ xs: 12, md: 8 }}>
        <TextInput
          label="Name of the rule"
          focus={focus === 'name'}
          value={props.formData.name}
          required={props.requiredFields.includes('name')}
          onChange={props.setFormData('name')}
          isReadOnly={props.isPreview}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 8 }}>
        <WrapperEntitySelector
          label="Identifier for the type of event that triggers the warning"
          //focus={focus === 'logicalId'}
          value={props.formData.eventTypeId}
          required={props.requiredFields.includes('eventTypeId')}
          onChange={v => props.setFormData('eventTypeId')(null, v)}
          isReadOnly={props.isPreview}
          searchComponent={generateSearchEntitySelector('eventType')}
        />
      </Grid>
      {((props.formData.notes && props.isPreview) || !props.isPreview) && (
        <Grid size={{ xs: 12, md: 8 }}>
          <TextInput
            label="Additional notes"
            value={props.formData.notes}
            required={props.requiredFields.includes('notes')}
            onChange={props.setFormData('notes')}
            isReadOnly={props.isPreview}
          />
        </Grid>
      )}
    </Grid>
  );
};
export default MainInformationStep1;
